import { render, staticRenderFns } from "./categoryCom.vue?vue&type=template&id=11ce39b1&scoped=true"
import script from "./categoryCom.vue?vue&type=script&lang=js"
export * from "./categoryCom.vue?vue&type=script&lang=js"
import style0 from "./categoryCom.vue?vue&type=style&index=0&id=11ce39b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce39b1",
  null
  
)

export default component.exports